import React, { useState } from 'react';
import StackItem from './StackItem';

export const StackList = () => {
  const [selectedItems, setSelectedItems] = useState([]);
  const [lastSelectedId, setLastSelectedId] = useState(null);

  const items = [
    { id: '1', icon: 'fa-tasks', text: 'Complete project proposal', folder: true },
    { id: '2', icon: 'fa-user', text: 'Meet with John about design', folder: false },
    { id: '3', icon: 'fa-sticky-note', text: 'Review client feedback', folder: true },
    { id: '4', icon: 'fa-tasks', text: 'Update website content', folder: false },
    { id: '5', icon: 'fa-user', text: 'Call Sarah from marketing', folder: true },
    { id: '6', icon: 'fa-sticky-note', text: 'Prepare for tomorrow\'s meeting', folder: false },
    { id: '7', icon: 'fa-tasks', text: 'Send monthly reports', folder: true },
    { id: '8', icon: 'fa-user', text: 'Schedule team building event', folder: false },
    { id: '9', icon: 'fa-sticky-note', text: 'Order new office supplies', folder: true },
    { id: '10', icon: 'fa-tasks', text: 'Finish code review', folder: false }
  ];

  const children = [
    { icon: 'fa-tasks', text: 'Complete project proposal' },
    { icon: 'fa-user', text: 'Meet with John about design' },
    { icon: 'fa-sticky-note', text: 'Review client feedback' },
    { icon: 'fa-tasks', text: 'Update website content' },
    { icon: 'fa-user', text: 'Call Sarah from marketing' }
  ];

  const handleSelect = (itemId, shiftKey, ctrlKey) => {
    // Normal click (no modifier keys)
    if (!shiftKey && !ctrlKey) {
      setSelectedItems([itemId]);
      setLastSelectedId(itemId);
      console.log(`Selected item: ${itemId}`);
      return;
    }

    // Control/Command click (add/remove single item)
    if (ctrlKey) {
      setSelectedItems(prev => {
        // If item is already selected, remove it
        if (prev.includes(itemId)) {
          return prev.filter(id => id !== itemId);
        } 
        // Otherwise add it to selection
        else {
          return [...prev, itemId];
        }
      });
      setLastSelectedId(itemId);
      console.log(`Updated selection with Ctrl: ${[...selectedItems, itemId].join(', ')}`);
      return;
    }

    // Shift click (select range)
    if (shiftKey && lastSelectedId) {
      // Find indices of last selected and current items
      const allIds = items.map(item => item.id);
      const lastIndex = allIds.indexOf(lastSelectedId);
      const currentIndex = allIds.indexOf(itemId);
      
      // Determine range boundaries
      const startIndex = Math.min(lastIndex, currentIndex);
      const endIndex = Math.max(lastIndex, currentIndex);
      
      // Get all IDs in the range
      const rangeIds = allIds.slice(startIndex, endIndex + 1);
      
      setSelectedItems(rangeIds);
      console.log(`Selected range: ${rangeIds.join(', ')}`);
    }
  };

  return (
    <div style={{ 
      width: '100%', 
      maxWidth: '450px',
      overflow: 'hidden',
      border: '1px solid #ddd',
      borderRadius: '4px'
    }}>
      {items.map((item) => (
        <StackItem 
          key={item.id} 
          itemId={item.id}
          icon={item.icon} 
          text={item.text}
          folder={item.folder}
          children={item.folder ? children : null}
          selected={selectedItems.includes(item.id)}
          onSelect={handleSelect}
        />
      ))}
    </div>
  );
};

export default StackList;